import {Component, EventEmitter, Input, OnInit, Output, ViewChild, inject, DestroyRef} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TenantService } from 'src/app/services/api/tenant.service';
import { Permission } from '../../models/principal/permission';
import { translate } from '@jsverse/transloco';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ToastrService } from 'ngx-toastr';
import { InstancesService } from 'src/app/services/api/instances.service';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { ColumnFilterComponent } from '../instances-mgmt/column-filter/column-filter.component';
import { Subscription } from 'rxjs';
import { BreadcrumbItem } from '../../models/breadcrumb/breadcrumb-item';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { ManagementTypes } from 'src/app/models/management-type';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { CreateInstanceComponent } from './create-instance/create-instance.component';

const REQUIRED_PERMISSIONS = [
  Permission.ADD_TENANT,
];
@Component({
    selector: 'app-external-instance',
    templateUrl: './external-instance.component.html',
    styleUrls: ['./external-instance.component.scss'],
    standalone: false
})
export class ExternalInstanceComponent   implements OnInit {
  @ViewChild(MatSort, {static: true}) sort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
private destroyRef = inject(DestroyRef);
  DeployStatus = DeployStatus;
  breadcrumbItems: BreadcrumbItem[];
  ManagementTypes = ManagementTypes;

  tenant: string;
  instanceData: any;
  displayedColumns: string[] = ['name', 'tenantId', 'regionPair', 'dataZone', 'deploymentClass', 'status'];
  dataSource: any;
  Permission = Permission;
  permissionsMap: { [key: string]: boolean };
  showSpinner: any;
  searchSolutionText: any;
  dropdownsList: any = [];
  dashboardLink: any;
  instanceLink: any;
  pageSize: number;
  pageNumber = 1;

  paginationSize = 10;
  pageIndex = 0;
  showPagination = true;
  sortInfo: any;
  tenantList: any;
  tenantId: any;
  status: any;
  managementType: any;
  filteredColumns: any;
  clearData: boolean;
  subscription: Subscription;
  defaultInstances: any;
  searchText: string;
  defaultFilterOptions: any;
  selectedDefaultFilter: any;
  isFailed = false;
  statusList: any;
  isMultipleTenant = false;

  constructor(private route: ActivatedRoute, private authService: AuthService, private instanceService: InstancesService,
    private sidenavService: SidenavService, private toastrService: ToastrService, private tenantService: TenantService,
    public dateTimeFormatService: DateTimeFormatService, private customToastrService: CustomToastrService,
    private router: Router, private toastrErrorService: ToastrErrorService, private permissionsService: PermissionsService) {
    
  }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveUserPermissions(REQUIRED_PERMISSIONS);
    this.sidenavService.selectedMenu = 'LEFT_SIDE_NAV.EXTERNAL_INSTANCE';
    this.pageSize = parseInt(localStorage.getItem('pageSize'), 10);
    this.tenantId = this.sidenavService.externalTenantToInstance;
    if(this.tenantId) {
      localStorage.setItem('filteredExternalTenant', this.tenantId);
    }
    const tenantData = localStorage.getItem('filteredExternalTenant');
    if (tenantData) {
      if(tenantData.indexOf(',') > -1) {
        this.isMultipleTenant = true;
      } else {
        this.isMultipleTenant = false;
      }
      this.tenantId = tenantData;
    }
    const statusData = localStorage.getItem('filteredExternalStatus');
    if (statusData) {
      this.status = statusData;
    }

    const managementTypeData = localStorage.getItem('filteredExternalType');
    if (managementTypeData) {
      this.managementType = managementTypeData;
    }

    this.dashboardLink = ({label: translate('LEFT_SIDE_NAV.EXTERNAL')});
    this.instanceLink = ({label: translate('LEFT_SIDE_NAV.INSTANCE'), url: ['external-instance']});

    const statusOptions = [];
    const allStatus = Object.values(DeployStatus);
    allStatus.forEach(val => {
      statusOptions.push({value: val, selected: false});
    });

    const typeOptions = [
      {value: ManagementTypes.EXTERNAL, label: translate('INSTANCE_LIST.EXTERNAL'), selected: false},
      {value: ManagementTypes.EXTERNAL_FOR_ACTION, label: translate('INSTANCE_LIST.EXTERNAL_FOR_ACTION'), selected: false}
    ];
    this.dropdownsList = [
      {
        title: 'Tenant',
        placeholder: translate('INSTANCE_LIST.SELECT_TENANT'),
        key: 'tenant',
        options: []
      },
      {
        title: 'Status',
        placeholder: translate('INSTANCE_LIST.SELECT_STATUS'),
        key: 'status',
        options: []
      },
      {
        title: 'Type',
        placeholder: translate('INSTANCE_LIST.SELECT_TYPE'),
        key: 'type',
        options: typeOptions
      }
    ];
    this.defaultFilterOptions = [
      {
        label: translate('INSTANCE_LIST.ALL_INSTANCES'),
        selected: true
      },
      {
        key: DeployStatus.DEPLOYED,
        label: translate('INSTANCE_LIST.DEPLOYED_INSTANCES'),
        selected: false,
      },
      {
        key: DeployStatus.DEPLOYING,
        label: translate('INSTANCE_LIST.DEPLOYING_INSTANCES'),
        selected: false,
      },
      {
        key: DeployStatus.FAILED,
        label: translate('INSTANCE_LIST.FAILED_INSTANCES'),
        selected: false,
      },
    ];
    this.selectedDefaultFilter = this.defaultFilterOptions[0];
    this.statusList = [...new Set(statusOptions.map(item => item.value).sort((a, b) => (a.toLowerCase() < b.toLowerCase()) ? -1 : 1))];
    this.statusList.forEach((value) => {
      this.dropdownsList[1].options.push({value, selected: false});
    });
    this.managementType = ManagementTypes.EXTERNAL;
    this.clearData = true;
    this.tenant = this.authService.principal.provider;
    this.getTenants();
    this.getInstancesData(this.tenantId,
      this.status, this.managementType, this.searchSolutionText, this.pageSize);
  }

  /**
   * Getting a tenant List to be displayed in filter removing all the internal tenants.
   */
  getTenants(): void {
    this.dropdownsList[0].options = [];
    this.tenantService.getTenants()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        if (data) {
          data = data.filter(value => value.managementType === 'external');
          this.tenantList = [...new Set(data.map(item => item.tenantId).sort((a, b) => (a.toLowerCase() < b.toLowerCase()) ? -1 : 1))];
          this.tenantList.forEach((value) => {
          this.dropdownsList[0].options.push({value, selected: false});
        });
        }
      });
  }

  /**
   * Open the create isntance dialog to create instance
   */
  createInstance(): void {
      this.sidenavService.openInRightSidenav(CreateInstanceComponent)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((formData) => {
        if (!formData) {
          return;
        } else {
          this.getInstancesData(this.tenantId,
            this.status, this.managementType, this.searchSolutionText, this.pageSize);
        }
      });
  }

  /**
   * Getting a Instance List to be displayed in table.
   * @params - By sending tenantId, status, managementType, solutionId, pageSize, pageNumber.
   */
  getInstancesData(tenantId?, status?, managementType?, solutionId?, pageSize?, pageNumber?): void {
    this.showSpinner = true;
    this.isFailed = false;
    this.instanceData = [];

    let multipleTenant;
    if(tenantId) {
      const typeOfTenant = typeof tenantId;
      if (typeOfTenant === 'object') {
        this.tenantId = tenantId;
        multipleTenant = tenantId.toString();
        this.isMultipleTenant = tenantId.length > 1? true : false;
        if (tenantId.length > 1) {
          this.isMultipleTenant = true;
        } else {
          this.tenantId = tenantId.toString();
          this.isMultipleTenant = false;
        }
        
      } else if(tenantId.indexOf(',') > -1) {
        this.tenantId = tenantId.split(',');
        multipleTenant = tenantId;
        this.isMultipleTenant = true;
      } else {
        multipleTenant = tenantId;
        this.isMultipleTenant = false;
      }
      localStorage.setItem('filteredExternalTenant', tenantId);
    } else {
      localStorage.removeItem('filteredExternalTenant');
    }
    if(status) {
      localStorage.setItem('filteredExternalStatus', status);
      } else {
        localStorage.removeItem('filteredExternalStatus');
    }
    if(managementType) {
      localStorage.setItem('filteredExternalType', managementType);
      } else {
        localStorage.removeItem('filteredExternalType');
    }
    const instanceObj = {
      tenantId: multipleTenant,
      status,
      managementType,
      solutionId,
      pageSize,
      pageNumber
    };
    this.instanceService.getInstances(instanceObj)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
      if (data) {
        this.defaultInstances = data?.data;
          localStorage.setItem('pageSize', data.total);
          this.pageSize = data.total;
          this.showSpinner = false;
          const terminatedInstances = data.data.filter(instance => (instance.status === DeployStatus.TERMINATED ||
            instance.status === DeployStatus.TERMINATION_FAILED));
          this.instanceData = data;
          this.instanceData.data = data.data.filter(instance => (instance.status !== DeployStatus.TERMINATED &&
            instance.status !== DeployStatus.TERMINATION_FAILED));
          this.instanceData.data = [...this.instanceData.data, ...terminatedInstances];
          const bookmarkedInstances = JSON.parse(localStorage.getItem('bookmarks'));
          this.instanceData.data.forEach(instance => {
            if (bookmarkedInstances?.find(item => item.id === instance.id)) {
              instance.bookmarked = true;
            } else {
              instance.bookmarked = false;
            }
          });

          if (this.sortInfo) {
            const sortedData = this.sortInstanceData(this.sortInfo);
            this.dataSource = new MatTableDataSource(sortedData?.data?.slice(this.pageIndex, this.paginationSize));
          } else {
            data = data.data?.sort((a, b) => new Date(a?.dateCreated)?.getTime() - new Date(b?.dateCreated)?.getTime() ? -1 : 1);
            this.dataSource = new MatTableDataSource(this.instanceData.data?.slice(this.pageIndex, this.paginationSize));
          }
        }
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.customToastrService.errMessage(message, title);
        }, 500);
        this.showSpinner = false;
        this.isFailed = true;
      });
  }

  /**
   * Display the instance
   * @param data - instnce data
   */
  loadData(data?): void {
    this.breadcrumbs();
    this.pageIndex = 0;
    if (this.sortInfo) {
      const sortedData = this.sortInstanceData(this.sortInfo);
      this.dataSource = new MatTableDataSource(sortedData?.data?.slice(this.pageIndex, this.paginationSize));
    } else {
      this.dataSource = new MatTableDataSource(data?.slice(this.pageIndex, this.paginationSize));
    }
    this.searchInstance();
  }

  /**
   * Breadcrumbs of vies instance page
   */
  breadcrumbs(): void {
    this.breadcrumbItems = [];
      this.breadcrumbItems.push({icon: 'assets/images/home_icon.svg'}, {label: this.dashboardLink.label, url:[]}, {label: this.instanceLink.label,
        url: this.instanceLink.url});
  }

  /**
   * Sort the instance
   * @param event - the specific event
   */
  sortData(event): void {
    this.sortInfo = event;
    this.showPagination = false;
    setTimeout(() => {
      this.showPagination = true;
    }, 10);
    this.pageIndex = 0;
    this.instanceData.data = this.sortInstanceData(event);
    this.dataSource = new MatTableDataSource(this.instanceData.data?.slice(this.pageIndex, this.paginationSize));
  }

  /**
   * Sort the instance
   * @param event - sord data based on event
   * @returns - the data in ascending or descending order
   */
  sortInstanceData(event): any {
    return this.instanceData.data?.sort((a, b) => {
      let comparatorResult = 0;
      switch (event.active) {
        case 'name':
          comparatorResult = a?.name && b?.name ? a?.name?.localeCompare(b?.name) : !a?.name ? -1 : 1;
          break;
        case 'id':
          comparatorResult = a?.id && b?.id ? a?.id?.localeCompare(b?.id) : !a?.id ? -1 : 1;
          break;
        case 'dateCreated':
          comparatorResult = a?.dateCreated && b?.dateCreated ? new Date(a?.dateCreated)?.getTime() - new Date(b?.dateCreated)?.getTime()
            : !a?.dateCreated ? -1 : 1;
          break;
        case 'regionPair':
          comparatorResult = a?.region && b?.region ? a?.region?.localeCompare(b?.region)
            : !a?.region ? -1 : 1;
          break;
        case 'dataZone':
          comparatorResult = a?.dataZone && b?.dataZone ? a?.dataZone?.localeCompare(b?.dataZone)
            : !a?.dataZone ? -1 : 1;
          break;
        case 'deploymentClass':
          comparatorResult = a?.deploymentClass && b?.deploymentClass ? a?.deploymentClass?.localeCompare(b?.deploymentClass)
            : !a?.deploymentClass ? -1 : 1;
          break;
        case 'randomSuffix':
          comparatorResult = a?.randomSuffix && b?.randomSuffix ? a?.randomSuffix?.localeCompare(b?.randomSuffix)
            : !a?.randomSuffix ? -1 : 1;
          break;
        case 'deploymentClass':
          comparatorResult = a?.deploymentClass && b?.deploymentClass ? a?.deploymentClass?.localeCompare(b?.deploymentClass)
            : !a?.deploymentClass ? -1 : 1;
          break;
        case 'status':
          comparatorResult = a?.status && b?.status ? a?.status?.localeCompare(b?.status) : !a?.status ? -1 : 1;
          break;
        // case 'endpoints':
        //   comparatorResult = a?.endpoints && b?.endpoints ? a?.endpoints?.localeCompare(b?.endpoints)
        //     : !a?.endpoints ? -1 : 1;
        //   break;
        default:
          comparatorResult = a?.name && b?.name ? a?.name?.localeCompare(b?.name) : !a?.name ? -1 : 1;
          break;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
     });
  }

  /**
   * Pagination for the view instance
   * @param event - event of the pagination
   */
  pageChanged(event): any {
    if (event.length) {
      this.pageIndex = event.pageIndex;
      this.paginationSize = event.pageSize;
      const firstIndex = this.pageIndex * this.paginationSize;
      const data = this.instanceData.data.slice(firstIndex, firstIndex + this.paginationSize);
      this.dataSource = new MatTableDataSource(data);
    }
  }

  /**
   * Navigate to External instance page
   * @param instance - the instance
   */
  openInstanceDetails(instance): void {
    this.router.navigate(['/', this.authService.principal.provider, 'external-instance', instance.id]);
  }

  /**
   * Close the menu
   * @param data - type of management
   */
  closeMenu(data): void {
    if (data !== ManagementTypes.EXTERNAL && data !== ManagementTypes.EXTERNAL_FOR_ACTION){
      this.sidenavService.searchFilter.next(data);
      this.filteredColumnsFunction(data);
    }
  }

  /**
   * The default filter for the instance
   * @param option - the selected event
   */
  defaultFilterChanged(option): void {
    this.dropdownsList[1].selectedValue = option.key;
    this.selectedDefaultFilter = option;
    this.getInstancesData(this.dropdownsList[0].selectedValue,
      this.dropdownsList[1].selectedValue, this.managementType, this.searchSolutionText, this.pageSize);

    this.dropdownsList[1].options.forEach(item => item.selected = false);
    this.dropdownsList[1].options.find(item => item.value === option.key).selected = true;
    this.status = option.key;
  }

  /**
   * Handles the filter for the instance
   */
  filterColumns(): void {
    if(this.tenantId) {
      this.dropdownsList[0].options.filter((item) => {
        item.selected = false;
        if (this.isMultipleTenant && this.tenantId.find(tenant=> tenant == item.value)) {
          item.selected = true;
        } else if (item.value === this.tenantId) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[0].options.filter((item) => {
        item.selected = false;
      });
    }
    if(this.status) {
      this.dropdownsList[1].options.filter((item) => {
        if (item.value === this.status) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[1].options.filter((item) => {
        item.selected = false;
      });
    }
    if(this.managementType) {
      this.dropdownsList[2].options.filter((item) => {
        item.selected = false;
        if (item.value === this.managementType) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[2].options.filter((item) => {
        item.selected = false;
      });
    }
    const data = {
      name: translate('INSTANCE_STATUS.INSTANCE'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.dropdownsList,
      tenant: this.dropdownsList[0].options,
      status: this.dropdownsList[1].options,
      type: this.dropdownsList[2].options,
    };
    this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(filteredColumns => {
        if (filteredColumns) {
          this.clearData = true;
          this.filteredColumns = filteredColumns;
          if(filteredColumns[0] !== '') {
            this.tenantId = filteredColumns[0];
          }
          if(filteredColumns[1] !== ''){
            this.defaultFilterOptions.forEach(item => item.selected = false);
            this.defaultFilterOptions[0].selected = true;
            this.selectedDefaultFilter = this.defaultFilterOptions[0];
            this.status = filteredColumns[1];
          }
          if(filteredColumns[2] !== ''){
            this.defaultFilterOptions.forEach(item => item.selected = false);
            this.defaultFilterOptions[0].selected = true;
            this.selectedDefaultFilter = this.defaultFilterOptions[0];
            this.managementType = filteredColumns[2];
          }
          this.getInstancesData(this.tenantId,
            this.status, this.managementType, this.searchSolutionText, this.pageSize);
      }
    });
  }

  /**
   * Reset the selected property of the filter items
   * @param dataDeselected - selected filter item
   */
  filteredColumnsFunction(dataDeselected): void {
    if(dataDeselected) {
      if(this.isMultipleTenant && this.tenantId && this.tenantId.indexOf(dataDeselected) >= 0) {
        let selectedItem = this.tenantId.indexOf(dataDeselected);
        if (selectedItem >= 0) {
          this.tenantId.splice(selectedItem, 1);
        }
        if (this.tenantId.length > 1) {
          this.isMultipleTenant = true;
        } else {
          this.isMultipleTenant = false;
        }
      } else if(this.tenantId === dataDeselected) {
        this.tenantId = undefined;
        this.resetValue(this.dropdownsList[0]);
      } else if(this.status === dataDeselected) {
        this.status = undefined;
        this.resetValue(this.dropdownsList[1]);
      } else if(this.managementType === dataDeselected) {
        this.managementType = undefined;
      }

    }
    this.getInstancesData(this.tenantId,
      this.status, this.managementType, this.searchSolutionText, this.pageSize);
  }

  /**
   * Reset all the filter items
   */
  resetFilter(): void {
    this.tenantId = undefined;
    this.status = undefined;
    this.managementType = ManagementTypes.EXTERNAL;
    this.defaultFilterOptions.forEach(item => item.selected = false);
    this.defaultFilterOptions[0].selected = true;
    this.selectedDefaultFilter = this.defaultFilterOptions[0];
    this.clearData = false;
    this.sidenavService.searchFilter.next('data');
    this.resetAllValues();
    this.getInstancesData(this.tenantId,
      this.status, this.managementType, this.searchSolutionText, this.pageSize);
  }

  /**
   * Reset filter dropdown list
   * @param closedItem - the selected item to be reset
   */
  resetValue(closedItem): void {
    closedItem?.options?.forEach(element => {
      element.selected = false;
    });
  }

  /**
   * Reset all filter dropdowns
   */
  resetAllValues(): void {
    this.dropdownsList.forEach(element => {
     element?.options?.forEach(item => {
       item.selected = false;
     });
   });
  }

  /**
   * Search instance
   * @param event - the event
   */
  searchInstance(event?): void {
    if (event) {
      this.searchText = event.target.value;
    } else if (this.searchText) {
      this.searchText = this.searchText;
    }
    this.instanceData.data = this.defaultInstances;
    if (this.searchText) {
      this.instanceData.data =
      this.instanceData.data?.filter(item => item.name.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase()));
    } else {
      this.instanceData.data = this.defaultInstances;
    }
    this.pageSize = this.instanceData.data?.length;
    const data = this.instanceData.data?.slice(this.pageIndex, this.paginationSize);
    this.dataSource = new MatTableDataSource(data);
  }

}
